/**
 * Collector used when building without the SSM configuration, i.e. local and PR builds.
 */
const DEVELOP_LOGGING_URL =
  'https://collectors.au.sumologic.com/receiver/v1/http/ZaVnC4dhaV2dIa2htl70HnpEiyWMOiNf9Lv8TBVF3tm7yvEGqCEsOj6vFEjcfVtiSA7r5gaLI0wMAc3-porB-wTRet6lNf9Z0caJMjRMk0Wtj2_bvHqGZw=='

/**
 * App specific Sumo Logic collector.
 *
 * `process.env.LOGGING_URL` is inlined at build time by custom-webpack.config.js, taken from the
 * SSM configuration for the environment being built, so each app logs to its own collector without
 * reading another app's key out of the shared config at runtime.
 */
export const loggingUrl = process.env.LOGGING_URL ?? DEVELOP_LOGGING_URL
